<div class="option-execution dropdown-content-root">
	<div class="dropdown-title">
		<p class="title">{{ 'executeOption.title' | translate }}</p>
		<tui-icon
			class="icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>

	<div class="blocks">
		<div class="block">
			<div class="item">
				<div class="ticker">
					<div class="text">
						{{
							(position()?.option_type === optionTypeEnum.CALL
								? 'executeOption.side.buy'
								: 'executeOption.side.sell'
							) | translate
						}}
					</div>
					<span class="text">
						{{ position()?.option_ticker }}
					</span>
					<span class="text">
						{{ position()?.option_strike | price }}
					</span>
					<span
						class="text"
						highlight
						[isPositive]="position()?.option_type === optionTypeEnum.CALL"
						[isNegative]="position()?.option_type === optionTypeEnum.PUT"
					>
						{{ position()?.option_type | uppercase }}
					</span>
					<span class="text">
						{{ position()?.option_date | date: 'dd.MM.yyyy' }}
					</span>
				</div>
				<span class="value">{{ position()?.qty | quantity }}</span>
			</div>
			<div class="item">
				<span class="text">{{ 'executeOption.sharesPerContract' | translate }}</span>
				<span class="text">{{ 'executeOption.pcs' | translate }}</span>
			</div>
		</div>

		<div class="block">
			<div class="item">
				<div class="title">{{ 'executeOption.strikePrice' | translate }}</div>
				<span class="value">{{ position()?.option_strike | price }}</span>
			</div>
		</div>

		<div class="summary">
			<div class="order-summary">
				<div class="item">
					<p class="label">{{ 'executeOption.sum' | translate }}:</p>
					<span class="value">{{ totalSum() | price }}</span>
				</div>
				<div class="item">
					<p class="label">{{ 'executeOption.availableMoney' | translate }}:</p>
					<span class="value">{{ alpacaAccount()?.regt_buying_power ?? 0 | price }}</span>
				</div>
			</div>
		</div>

		<div class="btn-wrapper">
			<app-button
				appearance="primary"
				size="m"
				[isLoading]="isLoadingExecuteOption()"
				(clicked)="onExecuteOption()"
			>
				{{ 'executeOption.executeOption' | translate }}
			</app-button>
		</div>
	</div>
</div>
